var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgProfile(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M11.985 15.346c-3.868 0-7.17.585-7.17 2.927s3.281 2.947 7.17 2.947c3.867 0 7.17-.585 7.17-2.926s-3.282-2.948-7.17-2.948z",
    stroke: "#7210FF",
    strokeWidth: 1.527,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M11.985 12.006A4.596 4.596 0 107.389 7.41a4.58 4.58 0 004.563 4.596h.033z",
    stroke: "#7210FF",
    strokeWidth: 1.454,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

export default SvgProfile;